<!--
component: BrowseElevator
author: Ken Nakamura
description: 昇降機台帳閲覧画面
-->
<template>
  <section class="browse-elevator">
		<v-container fluid>
      <v-row>
      <div class="split">
        <div class="split left-box">
          <v-container fluid>
            <v-row>
              <v-col v-for="(page, index) in pages" :key="`page-${index}`"
                cols="12" md="6" lg="6" xl="6" style="margin:0; padding:0;">
                <v-btn
                  @click="showPage(index)"
                  large width="95%"
                  class="lighten-3 text-h7 my-2 blue"
                  :class="{yellow: currentPage==index}" >
                  {{ page.name }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn @click="printDaicho()"
                  dark color="#bb5577" x-large width="90%"
                  class="text-h5 mx-3 my-3">
                  印刷
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div class="split right-box">
          <div class="A4 preview-pane">
            <div class="gaiyo-header left-80">
            {{ukeNo}}
            </div>
            <br><br>
            <p class="gaiyo-section-header">昇降機の情報</p>
            <hr>
            <br>
            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【１．昇降機確認済番号・年月日】</div>
            </div>
            <div class="gaiyo-row">
              <div class="gaiyo-items">
                <div class="gaiyo-element left-40" style="width: 90mm;">{{daichoData.kknnNo}}</div>
                <div class="gaiyo-element left-135">{{dateTextToWareki(daichoData.kknnDay)}}</div>
              </div>
              <div v-for="(n,index) in wordwrap(daichoData.kknnNo,23)" :key="`kknnNo-${index}`">
                <br v-show="index>0"></div>
              <br>
            </div>
            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【２．変更確認済証番号・年月日】</div>
            </div>
            <div class="gaiyo-row">
              <div class="gaiyo-element left-40" style="width: 90mm;">{{daichoData.henkoNo}}</div>
              <div class="gaiyo-element left-135">{{dateTextToWareki(daichoData.henkoDay)}}</div>
              <br>
              <div v-for="(n,index) in wordwrap(daichoData.henkoNo,23)" :key="`henkoNo-${index}`">
                <br v-show="index>0"></div>
            </div>
            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【３．検査済証番号・年月日】</div>
            </div>
            <div class="gaiyo-row">
              <div class="gaiyo-items">
                <div class="gaiyo-element left-40" style="width: 90mm;">{{daichoData.kenzumiNo}}</div>
                <div class="gaiyo-element left-135">{{dateTextToWareki(daichoData.kenzumiDay)}}</div>
              </div>
              <div v-for="(n,index) in wordwrap(daichoData.kenzumiNo,23)" :key="`kenzumiNo-${index}`">
                <br v-show="index>0"></div>
              <br>
            </div>
            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【４．設置する建築物】</div>
            </div>
            <div class="gaiyo-row">
              <div class="gaiyo-minor-title">(1) 所在地</div>
              <div class="gaiyo-element left-40">{{daichoData.addr}}</div>
              <div v-for="(n,index) in wordwrap(daichoData.addr,33)" :key="`addr-${index}`">
                <br v-show="index>0"></div>
            </div>
            <div class="gaiyo-row">
              <div class="gaiyo-minor-title">(2) 用途</div>
              <div class="gaiyo-element left-40">{{daichoData.yotoNaiyo}}</div>
              <div v-for="(n,index) in wordwrap(daichoData.yotoNaiyo,33)" :key="`yoto-${index}`">
                <br v-show="index>0"></div>
            </div>
            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【５．昇降機の概要】</div>
            </div>
            <browse-elevator-gaiyo :gaiyos="daichoData.gaiyoList" />
            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【６．設置者】</div>
            </div>
            <div v-for="(nushi,index) in daichoData.builderList" :key="`owner-${index}`">
              <div class="gaiyo-row">
                <div class="gaiyo-minor-title">(1) 所在地</div>
                <div class="gaiyo-element left-40">{{nushi.addr}}</div>
                <div v-for="(n,index) in wordwrap(nushi.addr,33)" :key="`nushiaddr-${index}`">
                  <br v-show="index>0"></div>
              </div>
              <div class="gaiyo-row">
                <div class="gaiyo-minor-title">(2) 氏名</div>
                <div class="gaiyo-element left-40">{{nushi.bldrNameKanji}}</div>
                <div v-for="(n,index) in wordwrap(nushi.bldrNameKanji,33)" :key="`nushi-${index}`">
                  <br v-show="index>0"></div>
              </div>
            </div>
            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【７．メーカー・工事施工者】</div>
            </div>
            <div v-for="(seko,index) in daichoData.sekoshaList" :key="`maker-${index}`">
              <div class="gaiyo-row">
                <div class="gaiyo-element left-40">{{seko.skcpName}}</div>
                <div v-for="(n,index) in wordwrap(seko.skcpName,33)" :key="`seko-${index}`">
                  <br v-show="index>0"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </v-row>
    </v-container>
    <Dialog error :open="error!=0" :to="transition"
      title="昇降機台帳" :body="errorMessage" />
    <!--
    <Dialog error :open="error!=0" :ok="closeDialog"
      title="昇降機台帳" :body="errorMessage" />
    -->
  </section>
</template>

<script>
import BrowseElevatorGaiyo from '../components/elevator/BrowseElevatorGaiyo.vue'
import Dialog from '../components/Dialog.vue'
import { dateTextToWareki, wordwrap } from '../common/utils'

export default {
  components: {
    BrowseElevatorGaiyo,
    Dialog,
  },
  data () {
    return {
      error: 0,
      pages: [],
    }
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    ukeNo () {
      return this.$store.state.ukeNo;
    },
    gaiyoId () {
      return this.$store.state.gaiyoId;
    },
    gaiyo () {
      return this.daichoData;
    },
    daichoData () {
      return this.$store.state.gaiyoData;
    },
    errorMessage () {
      switch (this.error) {
        case 1:
          return 'ユーザが無効です。ログインし直して下さい。';
        case 2:
          return '昇降機台帳データが取得できません。'
        default:
          return '';
      }
    },
    transition () {
      switch (this.error) {
        case 1:
          return '/';
        case 2:
          return 'back'
        default:
          return '';
      }
    },
  },
  created () {
  },
  mounted() {
    if (this.unauthorized) {
      this.error = 1;
    }
    this.$store.commit('setCurrentPage', 8);
    this.message = `受付番号：${this.ukeNo}`;
  },
  methods: {
    /*
    closeDialog () {
      if (this.error == 1) {
        this.$router.replace('/');
      }
      else if (this.error == 2) {
        this.$router.back();
      }
      this.error = 0;
    },
    */
    /**
     * 昇降機台帳プレビュー画面を指定idまでスクロールする
     */
    scrollTo (id) {
      const el = this.$refs[id];
      el.scrollIntoView({ behavior: 'smooth' });
    },
    /**
     * 昇降機台帳を印刷する
     */
    printDaicho () {
      if (this.gaiyo != null) {
        this.$store.commit('setPrinting', true);
        window.print();
        this.$store.commit('setPrinting', false);
      }
    },
    dateTextToWareki(date) {
      return dateTextToWareki(date);  // from common/utils.js
    },
    wordwrap(text, len) {
      return wordwrap(text, len);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/common/common.css";
@import "../styles/gaiyo.css";
.A4 {
  /*
  width: 210mm;
  height: 296mm;
  */
  width: 190mm;
  height: 276mm;
  /*
  width: 172mm;
  height: 251mm;
  */
  page-break-after: auto;
}
/* 未使用
.item-row {
  font-size: small;
  line-height: 1;
  //margin-top: -1.2em;
  //margin-bottom: -1.2em;
}
*/
///* gaiyo.cssに任せてみる
.gaiyo-header {
  text-align: right;  
}
.gaiyo-section-header {
  font-size: 14pt;
}
.gaiyo-row {
  line-height: 8mm;
}
.gaiyo-major-title {
  font-size: 12pt;
}
.gaiyo-minor-title {
  font-size: 11pt;
}
.gaiyo-element {
  font-size: 11pt;
}
.left-40 {
  width: 130mm;
}
.left-130 {
  width: 50mm;
}
.left-135 {
  width: 50mm;
}
.split {
  position: absolute;
  width: 98%;
  height: 95%;
  padding: 0.0em;
  margin: 0;
}
.left-box {
  left: 0;
  width: 25%;
  padding: 0.3em;
  overflow-y: auto;
}
.right-box {
  right: 0;
  width: 75%;
  height: 100%;
  padding: 0 0.5em;
  overflow-y: scroll;
  overflow-x: auto;
  background-color: rgb(198, 226, 225);
}
.active {
  background-color: aquamarine;
}
@media print {
  @page {
    //size: A4 portrait !important;
    size: auto !important;
  }
  * {
    background: none !important;
    //overflow: hidden;
  }
  body {
    background: none !important;
    background-color: white !important;
  }
  .A4 {
    background: none !important;
    background-color: white !important;
  }
  .split {
    background: none !important;
    background-color: white !important;
  }
  .left-box {
    visibility: hidden;
    width: 0%;
  }
  .right-box {
    width: 100%;
    //overflow-x: hidden;
    //overflow-y: hidden;
    overflow-x: visible;
    overflow-y: visible;
    background: none !important;
    background-color: white !important;
  }
  .preview-pane {
    background: white;
    //width: 100% !important;
    //height: 100% !important;
  }
  /*
  .A4 {
    width: 190mm;
    height: 276mm;
    page-break-after: auto;
  }
  */
  /*
  @page {
    margin: 15mm 0 0;
  }
  body {
    margin: 0mm;
  }
  */
  main {
    margin: 0mm;
  }
}

</style>